export default __webpack_public_path__ + "static/B0222-810cc2cc8fc751923ce29a0734d4fb57.png";